/* ═══════════════════════════════════════════════════════════════════
   RESET product card motion — ONE canonical source (2026-07-03).
   Binds to every [data-rst-cardgrid] container on the page:
     1. 3D tilt toward cursor (max 14deg, instant tracking, 450ms settle)
        + cursor-tracking rose-gold glow per card (pointer/hover devices only)
     2. staggered RTL reveal (rightmost/first-DOM card first, IO-triggered)
   reduced-motion: reveal immediately, no tilt/glow.
   Ported from the approved products-grid.html (why-reset effect family).
   ═══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var motionOK = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hoverOK = window.matchMedia('(hover: hover)').matches;
  var MAX_TILT = 14;
  var EASE = 'cubic-bezier(0.4,0,0.2,1)';

  function bindCard(card) {
    if (card.dataset.rstCardBound) return;
    card.dataset.rstCardBound = '1';
    var glow = card.querySelector('.reset-trio__glow');
    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      var dx = (e.clientX - r.left) - r.width / 2;
      var dy = (e.clientY - r.top) - r.height / 2;
      var ry = (dx / (r.width / 2)) * MAX_TILT;
      var rx = -(dy / (r.height / 2)) * MAX_TILT;
      card.style.transform =
        'perspective(600px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) translateY(-6px)';
      if (glow) {
        glow.style.left = (e.clientX - r.left) + 'px';
        glow.style.top = (e.clientY - r.top) + 'px';
      }
    });
    card.addEventListener('mouseleave', function () {
      card.style.transition = 'transform 450ms ' + EASE + ', box-shadow 320ms ' + EASE + ', border-color 320ms ' + EASE;
      card.style.transform = '';
      setTimeout(function () { card.style.transition = ''; }, 470);
    });
  }

  function bindGrid(grid) {
    if (grid.dataset.rstGridBound) return;
    grid.dataset.rstGridBound = '1';
    var cards = [].slice.call(grid.querySelectorAll('.reset-trio__card'));
    if (!motionOK) { grid.classList.add('cards-in'); return; }
    if (hoverOK) cards.forEach(bindCard);
    var gio = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        cards.forEach(function (card, i) {
          card.style.transition = 'opacity 500ms ease-out, transform 500ms ease-out';
          card.style.transitionDelay = (i * 150) + 'ms';
        });
        grid.classList.add('cards-in');
        setTimeout(function () {
          cards.forEach(function (card) { card.style.transition = ''; card.style.transitionDelay = ''; });
        }, (cards.length * 150) + 560);
        obs.unobserve(grid);
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0.1 });
    gio.observe(grid);
  }

  function init() {
    [].slice.call(document.querySelectorAll('[data-rst-cardgrid]')).forEach(bindGrid);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* collection grid re-renders on filter/sort (facets AJAX) — rebind */
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();
